export const reportReasons = [
  { id: 'wrong_seat', label: '좌석 정보가 달라요' },
  { id: 'wrong_instance', label: '회차나 무대 구성이 달라요' },
  { id: 'stolen_photo', label: '남의 사진 같아요' },
  { id: 'no_photo_allowed', label: '촬영 금지 공연이에요' },
  { id: 'face_or_minor', label: '얼굴이나 아이가 찍혔어요' },
  { id: 'false_info', label: '사실과 달라요' },
  { id: 'discriminatory', label: '차별적인 표현이에요' },
  { id: 'other', label: '그 밖의 문제예요' },
] as const;
